import { render, staticRenderFns } from "./ConciergesCRUD.vue?vue&type=template&id=2036add4"
import script from "./ConciergesCRUD.vue?vue&type=script&lang=js"
export * from "./ConciergesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports